import createHeartComponent from '@finn-no/favorite-heart-component';
import React from 'react';
import ReactDOM from 'react-dom';
import RecommendationsWithFallback from '../../podlet-common/src/RecommendationsWithFallback';

const ele = document.getElementById('mlt-podlet-root');

if (ele) {
    const initialState = JSON.parse(
        document.getElementById('data-podlet-ssr-data').textContent
    );

    const {
        loginId,
        product,
        deviceType,
        adId,
        title,
        rows,
        pages,
        position,
        imagesCdnUrl,
        baseUrl,
        favoritesListUrl,
        christmasGiftList,
        debug,
        headingLevel,
        fallbackTitle,
        fallbackProduct,
        fallbackType,
        showKeywords,
        previewId,
        previewType,
        suppressTitle,
    } = initialState;

    // @TODO refactor out renderActions logic and into react-recommendations
    const Heart = createHeartComponent({
        userId: loginId,
        baseUri: favoritesListUrl,
    });

    const isMobile = deviceType !== 'desktop';
    const renderActions = ({ adId, itemType }) => (
        <Heart
            itemId={adId}
            itemType={itemType}
            isMobile={isMobile}
            variant="heart-on-image"
            christmasGiftList={christmasGiftList}
        />
    );

    ReactDOM.render(
        <div>
            <RecommendationsWithFallback
                adId={adId}
                baseUrl={baseUrl}
                imagesCdnUrl={imagesCdnUrl}
                pages={pages}
                position={position}
                deviceType={deviceType}
                product={product}
                renderActions={renderActions}
                rows={rows}
                title={title}
                type="mlt"
                debug={debug}
                headingLevel={headingLevel}
                fallbackTitle={fallbackTitle}
                fallbackProduct={fallbackProduct}
                forceFallback={false}
                fallbackType={fallbackType}
                showVerticalFilter={false}
                showKeywords={showKeywords}
                previewId={previewId}
                previewType={previewType}
                suppressTitle={suppressTitle}
            />
        </div>,
        ele
    );
}
